import { render, staticRenderFns } from "./WeedoITDetail.vue?vue&type=template&id=16a2bae9&"
import script from "./WeedoITDetail.vue?vue&type=script&lang=js&"
export * from "./WeedoITDetail.vue?vue&type=script&lang=js&"
import style0 from "./WeedoITDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports